import React from 'react';
import { Typography } from '@pwskills/rachnaui';

type Props = {
  projectContent: {
    title: string;
    img: string;
    desc: string;
  };
};

const ProjectContent = ({ projectContent }: Props) => {
  return (
    <div className="py-9 px-5 w-full">
      <Typography component="subheading" variant="bold" className="text-gray-900 line-clamp-2">
        {projectContent?.title}
      </Typography>
      <Typography component="body-small" className="line-clamp-5 text-gray-650">
        {projectContent?.desc}
      </Typography>
    </div>
  );
};

export default ProjectContent;
